export default defineNuxtPlugin(nuxtApp => {
  const methods = {
    formatCurrency(value) {
      if (import.meta.server) {
        // Use a default locale for server-side rendering
        return new Intl.NumberFormat('nl-NL',
          { style: 'currency', currency: "EUR" }
        ).formatToParts(value).map(val => val.value).join('');
      }

      let userLocale = navigator.language
      if (navigator.languages !== undefined) {
        userLocale = navigator.languages[0];
      }

      return new Intl.NumberFormat(userLocale,
        { style: 'currency', currency: "EUR" }
      ).formatToParts(value).map(val => val.value).join('');
    }
  }

  nuxtApp.provide('currency', methods);
})

